import i18next from 'i18next';

export default function getTranslationIfExists(key, defaultValue) {
  const result = i18next.t(key);
  return result !== key ? result : defaultValue;
}
